
<template>
    <div >
        <div class="news-bg" >
            <div class="container ">
              <el-button type="text" link @click="$router.go(-1);" class="btnReturn ">
                 <div class="flx-center">
                    <img style="width: 18px;height: 18px;margin-right: 5px;" :src="$ossUrl+'icons/returnOrder.png'" alt=""/>
                    <span  style="color: black;font-size: 18px;line-height: 18px;">返回</span>
                 </div>
              </el-button>

                <div v-for="(item,index) in newsList" :key="index" class="flx-align-start newsListBox" @click="goDetail(item)">
                  <div class="flx-wrap newsItemLeft">
                    <div class="newsListTitle show-nul-ellipsis">
                       {{ item.title }}
                      </div>
                      
                      <div class="newsListTime"><span v-if="item.time">{{ item.time }} ·</span> {{ item.company }}  </div>
                  </div>
                  <div>
                    <img class="newsImg"  :src="item.img" alt="">
                  </div>
                </div>
            </div> 
        
     
     
           
          
          </div>
          </div>
        <!--END HOME-->
  
  
        <!-- 
        <Services />
        <About />
        <Pricing />
        <Testimonial />
        <GetStarted />
        <Blog />
        <Contact />
   
        <Switcher /> -->
     
  </template>
  <script>

  import {ceshi} from '@/api/home.js'
  
  // import Switcher from "@/view/home/homeComponents/switcher";
  
  /**
   * Index-1 component
   */
  
  export default {
    name:"news",
    components: {
     
      // Switcher
    },
    created() {
    
    },
    data() {
      return {
       newsList:[
        {
          id:'13',
          title:'美通新航线 | Amazon SEND 欧洲海运渠道首家正式上线！',
          time:'',
          company:'美通供应链',
          img:this.$ossUrl+'images/Amazon SEND.png' ,
        },
        {
          id:'12',
          title:'【官宣】美通供应链正式升级为亚马逊FIST Elite承运商',
          time:'',
          company:'美通供应链',
          img:this.$ossUrl+'images/news/newsDetail/12-1.png' ,
        },
        {
          id:'0',
          title:'「送达时段自动更新(Delivery Window Automation，简称DW)」功能已正式上线！',
          time:'',
          company:'美通供应链',
          img:this.$ossUrl+'images/news/newsDetail/0-1.png' ,
        },
        {
          id:'1',
          title:'一波接一波，海运涨价潮为何停不下来？',
          time:'',
          company:'美通供应链',
          img:this.$ossUrl+'images/news/newsDetail/1-2.png' ,
        },
        {
          id:'2',
          title:'喜讯丨美通连续斩获4项荣誉奖项！',
          time:'',
          company:'美通供应链',
          img: this.$ossUrl+'images/news/newsDetail/2 (1).jpg' ,
        },
        {
          id:'3',
          title:'亚马逊合规化丨如何填好IEN编号？变体违规了怎么办？',
          time:'',
          company:'美通供应链',
          img: this.$ossUrl+'images/news/newsDetail/3 (1).png' ,
        },
        {
          id:'4',
          title:'重磅！美通正式成为亚马逊TSPN服务商',
          time:'',
          company:'美通供应链',
          img: this.$ossUrl+'images/news/newsDetail/4 (1).png' ,
        },
        {
          id:'5',
          title:'聚焦行业认可，美通荣获雨果跨境“2023最佳跨境物流奖” ',
          time:'',
          company:'美通供应链',
          img: this.$ossUrl+'images/news/newsDetail/5 (1).jpg' ,
        },
        {
          id:'6',
          title:'新动向：美通成为亚马逊ShipTrack承运商，助力卖家升级物流体验！',
          time:'',
          company:'美通供应链',
          img: this.$ossUrl+'images/news/newsDetail/6 (1).png' ,
        },
        {
          id:'7',
          title:'展会回顾丨2023亚马逊全球开店峰会美通参展圆满结束！',
          time:'',
          company:'美通供应链',
          img: this.$ossUrl+'images/news/newsDetail/7 (1).webp' ,
        },
        {
          id:'8',
          title:'喜报！热烈祝贺美通荣获亚马逊“2023金牌辅助”和“SPN一年级奖”',
          time:'',
          company:'美通供应链',
          img: this.$ossUrl+'images/news/newsDetail/8 (6).webp' ,
        },
        {
          id:'9',
          title:'重磅|祝贺美通&央视《信用中国》首播告捷！',
          time:'',
          company:'美通供应链',
          img: this.$ossUrl+'images/news/newsDetail/9 (1).webp' ,
        },
        {
          id:'10',
          title:'喜讯！美通供应链正式加入亚马逊SPN认证服务商！',
          time:'',
          company:'美通供应链',
          img: this.$ossUrl+'images/news/newsDetail/10 (5).webp' ,
        },
       ]
      };
    },
    methods: {
      goDetail(item) {
        this.$router.push({
          name: 'newsDetail',
          query: {
            id: item.id
          }
        });
      }
    }
    
  };
  </script>
  <style src="./index.css" scoped>
  
  
  </style>